// material
import { experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import {
  Box,
  Card,
  Grid,
  Typography,
  Stack,
  Button,
  Divider,
  OutlinedInput,
  Tab,
  Tabs,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  useMediaQuery,
  Checkbox,
} from '@material-ui/core'
//
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { useEffect, useRef, useState } from 'react'
import { capitalCase } from 'change-case'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import { LoadingButton } from '@material-ui/lab'
import { storage } from 'src/firebase/firebase'
import { getDownloadURL, uploadBytesResumable, ref as imageref, deleteObject } from '@firebase/storage'
import { Upload, UploadFileSharp } from '@material-ui/icons'
import Scrollbar from 'src/components/Scrollbar'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import { DialogAnimate } from 'src/components/animate'
import axios from 'axios'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import Images from './Images'
import Videos from './Videos'
import OtherFiles from './OtherFile'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'
import { supabase } from '../../../../supabase/supabaseClient';

const getFileType = (fileType) => {
  console.log(fileType, '------------')
  if (fileType.startsWith('image/')) {
    return 'image';
  } else if (fileType.startsWith('video/')) {
    return 'video';
  } else {
    return 'other';
  }
};
const validateFile = (file) => {
  const allowedFileTypes = ['pdf', 'doc', 'docx', 'csv', 'txt', 'image/*', 'video/*'];
  const maxFileSize = 1024 * 1024 * 1024; // 1GB


  const getFileExtension = (fileName) => {
    const matches = fileName.match(/\.[0-9a-z]+$/i);
    return matches ? matches[0].toLowerCase() : null;
  };
  const fileExtension = getFileExtension(file.name);

  if (!fileExtension || !allowedFileTypes.includes(fileExtension)) {
    console.log(`File type not allowed: ${file.name}`);
    return false;
  }


  if (file.size > maxFileSize) {
    console.log(`File size exceeds the limit: ${file.name}`);
    return false;
  }

  return true;
};
export default function Attachments({
  taskId,
  projectId,
  refresh,
  setRefresh,
  currentTab,
  details,
  taskData,
  taskAttachments,
  mirrored,
  targetFacilityId,
  canManage = true,
}) {
  const theme = useTheme()
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const fileInputRef = useRef()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [progress, setProgress] = useState(false)
  const [secTab, setSecTab] = useState('Images')
  const [openAttachment, setOpenAttachment] = useState(false)
  const [attachments, setAttachments] = useState({})
  const [images, setImages] = useState([])
  const [videos, setVideos] = useState([])
  const [otherAttachments, setOtherAttachments] = useState([])
  const [approvedTaskImages, setApprovedTaskImages] = useState([])
  const [processing, setProcessing] = useState(false)
  const [selectedModalDownloads, setSelectedModalDownloads] = useState([])
  const fetchAllAttachments = async () => {
    try {
      setProcessing(true)
      const res = await axios.post(`${REST_API_END_POINT}project-task/fetch-all-attachment`, {
        taskId, projectId,mirrored,targetFacilityId
      })
      if (res.data && res.data.attachments) {
        const images = [];
        const videos = [];
        const otherAttachments = [];

        res.data.attachments.forEach((data) => {
          console.log(data.file_type)

          switch (data.extension) {
            case 'image':
              images.push(data);
              break;
            case 'video':
              videos.push(data);
              break;
            case 'other':
              otherAttachments.push(data);
              break;
            default:
              // Handle unexpected cases if needed
              break;
          }
        });
        setImages(images);
        setVideos(videos);
        const filteredTaskAttachments = taskAttachments
        .filter(att => 
          att.extension !== 'image' &&
          att.extension !== 'img' &&
          !att.file_type?.startsWith('image/')
        )
        .map(att => ({
          ...att,
          file_url: att.name,  
          name: '',
          ID: att.id        
        }));
      
       const finalisedAttachments = [...otherAttachments, ...filteredTaskAttachments];
        setOtherAttachments(finalisedAttachments);
      }
    } catch (error) {
      console.log(error)
    }
    finally{
      setProcessing(false)
    }
  }
  useEffect(() => {
    fetchAllAttachments()
  }, [taskId, projectId, refresh,taskAttachments])
  console.log(otherAttachments, '-----------otherAttachments')
  const TABS = [
    {
      value: 'Images',
      component: <Images refresh={refresh} setRefresh={setRefresh} images={images} taskId={taskId} projectId={projectId} data={taskData} taskAttachments={taskAttachments} canManage={canManage} />,
    },
    {
      value: 'Videos',
      component: <Videos refresh={refresh} setRefresh={setRefresh} videos={videos} taskId={taskId} projectId={projectId} canManage={canManage} />,
    },
    {
      value: 'Files',
      component: <OtherFiles refresh={refresh} setRefresh={setRefresh} data={otherAttachments} videos={videos} taskId={taskId} projectId={projectId} taskAttachments ={taskAttachments} processing={processing} canManage={canManage} />,
    },
  ]
  const handleTab = (event, newValue) => {
    setSecTab(newValue)
  }
  // const handleFileChange = async (event) => {
  //   const files = event.target.files;

  //   if (files.length === 0) {
  //     return;
  //   }

  //   const uploadPromises = Array.from(files).map(async (file) => {
  //     // if (!validateFile(file)) {
  //     //   console.log(`Invalid file: ${file.name}`);
  //     //   return null;
  //     // }
  //     const isImage = file?.type?.startsWith('image/') || file?.type === 'img' || file?.type === 'image';
  //     const isVideo = file?.type?.startsWith('video/');
  //     const isPdf = file?.type === 'application/pdf' || file?.type === "other" || file?.type === "pdf" ;
  //     if (!isImage && !isPdf && !isVideo){
  //       enqueueSnackbar('Please select a valid file. Only Images, Videos and PDF are allowed', { variant: 'error' })
  //       return;
  //     }
  //     const filename = new Date().getTime() + file.name;
  //     const storageRef = imageref(storage, filename);
  //     const uploadTask = uploadBytesResumable(storageRef, file);

  //     return new Promise((resolve, reject) => {
  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //           setProgress(true)
  //         },
  //         (error) => {
  //           console.error(error.message);
  //           setProgress(false)
  //           reject(error);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref)
  //             .then((downloadURL) => {
  //               console.log(downloadURL, '-------------downloadURL');
  //               resolve({ downloadURL, fileType: getFileType(file.type) });
  //             })
  //             .catch((error) => {
  //               console.error(error.message);
  //               reject(error);
  //             });
  //         }
  //       );
  //     });
  //   });

  //   try {
  //     const validFileUploads = await Promise.all(uploadPromises);
  //   const newAttachments = validFileUploads.reduce((acc, { downloadURL, fileType }) => {
  //     console.log(fileType,'-------------',downloadURL)
  //     acc[fileType] = acc[fileType] || [];
  //     acc[fileType].push(downloadURL);
  //     return acc;
  //   }, {});
  //   console.log(newAttachments,'-----------newAttachments')
  //   // setAttachments((prevAttachments) => ({ ...prevAttachments, ...newAttachments }));
  //   setAttachments((prevAttachments) => ({
  //     ...prevAttachments,
  //     image: [...(prevAttachments.image || []), ...(newAttachments.image || [])],
  //     video: [...(prevAttachments.video || []), ...(newAttachments.video || [])],
  //     other: [...(prevAttachments.other || []), ...(newAttachments.other || [])],
  //   }));
  //     setProgress(false)
  //   } catch (error) {
  //     console.error('Error uploading files:', error);
  //   }
  // };
  const handleFileChange = async (event) => {
    if (!canManage) {
      enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
      return
    }
    const files = event.target.files;

    if (files.length === 0) return;

    const uploadPromises = Array.from(files).map(async (file) => {
      const normalizedFileName = file.name.toLowerCase();
      const fileExt = normalizedFileName.split('.').pop();
      const isDesignFile = ['ai', 'eps', 'ps', 'psd', 'tif', 'tiff', 'indd', 'indt'].includes(fileExt);
      const isImage = file?.type?.startsWith('image/') || file?.type === 'img' || file?.type === 'image';
      const isVideo = file?.type?.startsWith('video/');
      const isPdf = file?.type === 'application/pdf' || file?.type === 'pdf' || fileExt === 'pdf';
      const isOtherAllowed = ['doc', 'docx', 'xls', 'xlsx', 'csv', 'txt'].includes(fileExt);

      if (!isImage && !isPdf && !isVideo && !isDesignFile && !isOtherAllowed) {
        enqueueSnackbar('Please select a valid file. Images, Videos, PDFs, and Design files are allowed', { variant: 'error' });
        return null;
      }

      const timestamp = new Date().getTime();
      const safeName = file.name.replace(/\s+/g, '_');
      const fileName = `${timestamp}_${safeName}`;

      let folder = '';
      if (isImage) folder = 'images';
      else if (isVideo) folder = 'videos';
      else folder = 'files';

      const filePath = `all-jobs/job-details/tasks/${folder}/${fileName}`;

      try {
        const { data, error } = await supabase.storage
          .from('signwise-attachments') // replace with your bucket name
          .upload(filePath, file);

        if (error) {
          throw error;
        }

        const { data: publicUrlData } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        return {
          downloadURL: publicUrlData.publicUrl,
          fileType: getFileType(file.type)
        };

      } catch (error) {
        console.error(error.message);
        enqueueSnackbar('Upload failed. Try again later.', { variant: 'error' });
        return null;
      }
    });

    try {
      setProgress(true);
      const uploadedFiles = await Promise.all(uploadPromises);

      const newAttachments = uploadedFiles.reduce((acc, file) => {
        if (!file) return acc;
        const { downloadURL, fileType } = file;
        acc[fileType] = acc[fileType] || [];
        acc[fileType].push(downloadURL);
        return acc;
      }, {});

      setAttachments((prev) => ({
        ...prev,
        image: [...(prev.image || []), ...(newAttachments.image || [])],
        video: [...(prev.video || []), ...(newAttachments.video || [])],
        other: [...(prev.other || []), ...(newAttachments.other || [])],
      }));

    } catch (error) {
      console.error('Error uploading files:', error);
    } finally {
      setProgress(false);
    }
  };
  const RemoveAttachFromSubmit = (type, value) => {
    const deleteRef = imageref(storage, value);

    deleteObject(deleteRef)
      .then(() => {
        // File deleted successfully
        setAttachments(prevState => ({
          ...prevState,
          [type]: (prevState[type] || []).filter(item => item !== value)
        }));
        console.log('File deleted successfully');
      })
      .catch(error => {
        console.error('Error deleting file:', error);
      });
  };

  const handleSubmit = async () => {
    try {
      if (!canManage) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
        return
      }
      if (Object.keys(attachments).length === 0) {
        enqueueSnackbar('Please provide attachments', { variant: 'warning' });
        return;
      }
      let user = JSON.parse(window.localStorage.getItem('user'))
      const res = await axios.post(`${REST_API_END_POINT}project-task/add-attachment`, {
        attachments, taskId, projectId, userId: user.user_id,
      })
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
        setRefresh(!refresh)
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
      }
      setAttachments({})
      setOpenAttachment(false)
    } catch (error) {
      console.log(error)
    }
  }
  let user = JSON.parse(window.localStorage.getItem('user'))
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {(currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab != "Completed" && currentTab != "Hold" && details?.status != 3 && details?.hold != 1 && details?.is_rejected != 1 && !mirrored && canManage) && <Box width={'100%'} display={'flex'} justifyContent={'flex-end'} mb={2}>
          <Button onClick={() => setOpenAttachment(!openAttachment)} variant="contained" disabled={user.user_type == 3 ? true : false}>ADD ATTACHMENT</Button>
        </Box>}
        <Card
          sx={{
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'scale(1.02)',
            },
          }}

        >
          <Stack spacing={2}>
            <Stack direction={'row'} spacing={3} alignItems={'center'} p={2}>
              <Typography variant="h4">{'Attachments'}</Typography>
            </Stack>
            <Box px={2}>
              <Divider />
              <Tabs
                value={secTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleTab}
              >
                {TABS.map((tab) => (
                  <Tab
                    disableRipple
                    key={tab.value}
                    label={
                      <Typography variant="overline">
                        {capitalCase(tab.value)}
                      </Typography>
                    }
                    icon={tab.icon}
                    value={tab.value}
                  />
                ))}
              </Tabs>
            </Box>
            <Stack sx={{ alignItems: 'center', mb: 2 }} spacing={2}>
              {TABS.map((tab) => {
                const isMatched = tab.value === secTab
                return (
                  isMatched && (
                    <Box sx={{ width: '80%' }} key={tab.value}>
                      {tab.component}
                    </Box>
                  )
                )
              })}
            </Stack>
            {/* <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              py={15}
            >
              No images found
            </Box> */}
          </Stack>
        </Card>
        {/* this  modal represent to add attachments */}
        <Modal open={openAttachment} modalTitle={'Add Attachment'} handleClose={() => setOpenAttachment(false)}>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}
            spacing={{ xs: 2, sm: 3 }}
            mb={2}
          >
            {canManage ? (
              <>
                <LoadingButton
                  variant="outlined"
                  size="small"
                  sx={{ height: 40 }}
                  onClick={() => fileInputRef.current.click()}
                  loading={progress}
                  startIcon={<UploadFileSharp />}
                >
                  Upload
                </LoadingButton>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  // accept="image/*,video/*,application/pdf"
                  multiple
                />
              </>
            ) : null}
            <AttachmentDownloadAllButton
              files={selectedModalDownloads}
              allFiles={[
                ...(attachments?.image || []),
                ...(attachments?.video || []),
                ...(attachments?.other || []),
              ]}
              onToggleSelectAll={(checked) => {
                const all = [
                  ...(attachments?.image || []),
                  ...(attachments?.video || []),
                  ...(attachments?.other || []),
                ]
                setSelectedModalDownloads(checked ? [...all] : [])
              }}
              label="Download Selected"
              size="small"
              sx={{ height: 40 }}
            />
          </Stack>
          {(attachments && Object.keys(attachments)?.length > 0) && <>
            <Box>
              <Scrollbar sx={{ width: '100%', height: 250 }}>
                <ImageList gap={8} cols={mdd ? 1 : xld ? 3 : 2}>

                  {attachments?.video && attachments.video.map((videoUrl, index) => (
                    <ImageListItem key={index} sx={{ position: 'relative' }}>
                      <Checkbox
                        checked={selectedModalDownloads.includes(videoUrl)}
                        onChange={() => {
                          setSelectedModalDownloads((prev) =>
                            prev.includes(videoUrl)
                              ? prev.filter((u) => u !== videoUrl)
                              : [...prev, videoUrl],
                          )
                        }}
                        sx={{ position: 'absolute', top: 4, left: 4, zIndex: 12, bgcolor: 'rgba(255,255,255,0.8)' }}
                      />
                      <ImageListItemBar
                        actionIcon={
                          canManage ? (
                            <UserMoreMenu
                              onDelete={() => RemoveAttachFromSubmit('video', videoUrl)}
                              noEdit
                            />
                          ) : null
                        }
                      />
                      <video width="300" height="300" controls>
                        <source src={`${videoUrl}?w=300&h=300&fit=crop&auto=format`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>

                    </ImageListItem>
                  ))}
                  {attachments?.other && attachments?.other.map((url, index) => {
                    const fileExt = url.split('.').pop()?.split('?')[0]?.toLowerCase();
                    const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                    const isGoogleFile = ['ai', 'eps', 'ps', 'psd', 'tif', 'tiff', 'indd', 'indt'].includes(fileExt);
                    
                    return (
                      <Card key={index} sx={{ p: 3, maxWidth: 368, mx: 'auto', position: 'relative' }}>
                        <Checkbox
                          checked={selectedModalDownloads.includes(url)}
                          onChange={() => {
                            setSelectedModalDownloads((prev) =>
                              prev.includes(url)
                                ? prev.filter((u) => u !== url)
                                : [...prev, url],
                            )
                          }}
                          sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12, bgcolor: 'rgba(255,255,255,0.8)' }}
                        />
                        {isOfficeFile ? (
                          <iframe
                            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
                            title={url}
                            style={{ width: '300px', height: '300px', border: 0 }}
                          />
                        ) : isGoogleFile ? (
                          <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`}
                            title={url}
                            style={{ width: '300px', height: '300px', border: 0 }}
                           sandbox="allow-scripts allow-same-origin" />
                        ) : (
                          <embed src={url} type="application/pdf" width="300" height="300px" />
                        )}
                        {canManage ? (
                          <UserMoreMenu
                            onDelete={() => RemoveAttachFromSubmit('other', url)}
                            noEdit
                          />
                        ) : null}
                      </Card>
                    );
                  })}
                  {attachments?.image && attachments.image.map((imageUrl, index) => (
                    <ImageListItem key={index} sx={{ position: 'relative' }}>
                      <Checkbox
                        checked={selectedModalDownloads.includes(imageUrl)}
                        onChange={() => {
                          setSelectedModalDownloads((prev) =>
                            prev.includes(imageUrl)
                              ? prev.filter((u) => u !== imageUrl)
                              : [...prev, imageUrl],
                          )
                        }}
                        sx={{ position: 'absolute', top: 4, left: 4, zIndex: 12, bgcolor: 'rgba(255,255,255,0.8)' }}
                      />
                      <img
                        srcSet={`${imageUrl}?w=248&fit=crop&auto=format&dpr=2 2x`}
                        src={`${imageUrl}?w=248&fit=crop&auto=format`}
                        loading="lazy"
                      />
                      <ImageListItemBar
                        actionIcon={
                          canManage ? (
                            <UserMoreMenu
                              onDelete={() => RemoveAttachFromSubmit('image', imageUrl)}
                              noEdit
                            />
                          ) : null
                        }
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Scrollbar>
            </Box>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              {canManage ? (
                <LoadingButton onClick={() => handleSubmit()} variant='contained' size='small'>
                  Submit
                </LoadingButton>
              ) : null}
              <Button variant='outlined' onClick={() => { setAttachments({}), setOpenAttachment(false) }} size='small'>
                Cancel
              </Button>
            </Box>
          </>}
        </Modal>
      </Grid>
    </Grid>
  )
}
